


























import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "GroupSelectedInformer",
  components: { BaseSpinner, BaseIcon },
  props: {
    loading: { type: Boolean, default: false },
    selectedGroupCount: { type: Number, default: 0 },
    excludedGroupCount: { type: Number, default: 0 },
    recipientCount: { type: Number, default: 0 },
  },
});
